import { render } from "./StaffActivityCard.vue?vue&type=template&id=15752672&scoped=true"
import script from "./StaffActivityCard.vue?vue&type=script&lang=js"
export * from "./StaffActivityCard.vue?vue&type=script&lang=js"

import "./StaffActivityCard.vue?vue&type=style&index=0&id=15752672&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15752672"]])

export default __exports__